module.exports = __webpack_public_path__ + "img/onnuri_0327.beb26f05.png";